export const featureFlags = {
  inboxCalls: process.env.REACT_APP_FEATURE_INBOX_CALLS === 'true',
  organization: process.env.REACT_APP_FEATURE_ORGANIZATION === 'true',
  voice: process.env.REACT_APP_FEATURE_VOICE === 'true',
  tablesAssistant: process.env.REACT_APP_FEATURE_TABLES_ASSISTANT === 'true',
  rtaConfiguration: process.env.REACT_APP_FEATURE_RTA_CONFIGURATION === 'true',
  teams: process.env.REACT_APP_FEATURE_TEAMS === 'true',
  qaAgent: process.env.REACT_APP_FEATURE_QA_AGENT === 'true',
  skills: process.env.REACT_APP_FEATURE_SKILLS === 'true',
  // Dashboards (PRD - Dashboards, épico SL-1657). A brand-new, user-visible area,
  // so it ships behind a flag and rolls out gradually as the PRD asks.
  dashboards: process.env.REACT_APP_FEATURE_DASHBOARDS === 'true',
  // Observability (PRD - Observability, epic AGE-356). The agent's log reads a mock
  // until the backend exposes it, so it must stay off wherever customers are.
  observability: process.env.REACT_APP_FEATURE_OBSERVABILITY === 'true',
  // Learning (CIB-1256): the in-app guide to what can be done from the app, the API and
  // MCP, plus the release notes. Rolls out on dev and staging before production.
  learning: process.env.REACT_APP_FEATURE_LEARNING === 'true',
  // Integrations (PRD - Integraciones, epic SL-1561). The page reads mock connections and its
  // permissions are not in the role matrix yet, so it stays a DEV-only draft.
  integrations: process.env.REACT_APP_FEATURE_INTEGRATIONS === 'true',
  // Coarse gate for the channels that are still not production-ready
  // (web-voice, phone-voice). WhatsApp Business used to ride on this flag too;
  // it now has its own so it can ship without exposing the voice channels.
  extraChannels: process.env.REACT_APP_FEATURE_EXTRA_CHANNELS === 'true',
  whatsappBusiness: process.env.REACT_APP_FEATURE_WHATSAPP_BUSINESS === 'true',
  // The "WhatsApp Voice" MODE inside the WhatsApp Business channel (voice notes).
  // Independent of `whatsappBusiness`: the channel can ship text-only.
  whatsappVoice: process.env.REACT_APP_FEATURE_WHATSAPP_VOICE === 'true',
  // Telegram channel (VOX-321): a Telegram bot connected to an agent. DEV only for now.
  telegram: process.env.REACT_APP_FEATURE_TELEGRAM === 'true',
  // Secrets & variables tab (PRD - Skills, Feature 17.2, SL-1763). The tab calls the
  // Account Vault API (SL-1762), so turn it on only where that stack is deployed and
  // verified (DEV today); STAGING and PROD wait for the checklist in
  // openspec/changes/sl-1763-vault-secrets-tab/tasks-post-merge.md.
  vaultSecrets: process.env.REACT_APP_FEATURE_VAULT_SECRETS === 'true',
} as const;
